export const companyHasModule = (company, moduleName) => (company?.enabledModules || []).includes(moduleName);
